import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../redux/store';
import { deleteNotification } from "../../../redux/actions/notifications.actions";
import { ModalProps } from "../../../components/common/Interfaces/Modals";
import ModalShell, { ModalLoading } from "../../../components/common/Modals/ModalShell";

const DeleteNotificationModal: React.FC<ModalProps> = ({open, setOpen, object}) => {
    const notif = object;

    const handleClose = () => { handleReset(); setOpen(false); };
    const handleReset = () => { setSubmitted(false); };

    const dispatch = useDispatch<AppDispatch>();
    const { accessToken } = useSelector((state: RootState) => state.user);
    const { error, loading } = useSelector((state: RootState) => state.notifications);
    const [submitted, setSubmitted] = useState(false);

    const handleDelete = async (e: React.FormEvent) => {
      e.preventDefault();
      setSubmitted(true);
      await dispatch(deleteNotification(notif?.id));
    };

  const confirming = !submitted && !loading;
  const deleting = !confirming && loading && !error;

  return (
    <ModalShell
      open={open}
      onClose={handleClose}
      size="sm"
      busy={deleting}
      tone={deleting ? undefined : confirming ? "warning" : error ? "error" : "success"}
      title={confirming ? `Delete "${notif?.title}"?` : deleting ? "Deleting…" : error ? "An error occurred" : "Notification deleted"}
      actions={deleting ? undefined : confirming ?
        <>
          <button className="btn" onClick={handleClose}>Cancel</button>
          <button className="btn btn-danger" onClick={handleDelete} disabled={!accessToken}>Delete</button>
        </>
        : error ?
        <>
          <button className="btn" onClick={handleClose}>Close</button>
          <button className="btn btn-primary" onClick={handleReset}>Try again</button>
        </>
        :
        <button className="btn btn-primary" onClick={handleClose}>OK</button>
      }
    >
      {confirming ?
        <p>This action cannot be undone.</p>
        : deleting ?
        <ModalLoading/>
        : error ?
        <p>{error}</p>
        :
        <p>Notification successfully deleted.</p>
      }
    </ModalShell>
  );
};

export default DeleteNotificationModal;
